import { Link } from "react-router-dom";
import Seo from "../components/seo/Seo";
import RootLayout from "../layouts/RootLayout";

const Page404 = () => (
    <RootLayout>
        <Seo
            title="Page Not Found | Trustpoint Healthcare Solutions"
            description="The page you are looking for could not be found."
            pathname="/404"
        />

        <main className="flex-1 flex items-center justify-center section-padding-lg my-auto">
            <div className="text-center max-w-xl mx-auto">
                <p className="label-md text-accent mb-4 uppercase tracking-widest">404 Error</p>
                <h1 className="heading-xl mb-6 text-secondary">Page Not Found</h1>
                <p className="paragraph-lg text-gray-500 mb-10">
                    We couldn't locate the page you're searching for. It might have been moved or doesn't exist anymore.
                </p>
                <Link to="/" className="btn-primary-lg inline-block">
                    Return to Homepage
                </Link>
            </div>
        </main>
    </RootLayout>
);

export default Page404;
